import { RawFile } from "@mapmycustomers/shared/types/File";

import hasMimeType, {
  AUDIO_ANY,
  DOCUMENT_PDF,
  IMAGE_ANY,
  TEXT_ANY,
  VIDEO_ANY,
} from "@app/util/mimeType";

const canPreview = (file: RawFile) =>
  hasMimeType(file, [...IMAGE_ANY, ...VIDEO_ANY, ...AUDIO_ANY, ...DOCUMENT_PDF, ...TEXT_ANY]);

export default canPreview;
